import { render, staticRenderFns } from "./forget.html?vue&type=template&id=176002c4&scoped=true&"
import script from "./forget.js?vue&type=script&lang=js&"
export * from "./forget.js?vue&type=script&lang=js&"
import style0 from "./forget.sass?vue&type=style&index=0&id=176002c4&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176002c4",
  null
  
)

component.options.__file = "forget.vue"
export default component.exports